import { render, staticRenderFns } from "./ReferenceCardSkeletonLoader.vue?vue&type=template&id=1ca34c5a&scoped=true&"
import script from "./ReferenceCardSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./ReferenceCardSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCardSkeletonLoader.vue?vue&type=style&index=0&id=1ca34c5a&lang=scss&scoped=true&"
import style1 from "./ReferenceCardSkeletonLoader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca34c5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
